import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getPortfolioDashboardCostGraph } from "../../../api/portfolio/Portfolio";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const CostGraph = ({ id, authToken = null }) => {
  const [options, setOptions] = useState({
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: ["Actual Budget", "Spent Budget", "Remaining Amount"],
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "normal",
      },
    },
    series: [],
  });

  useEffect(() => {
    getGraph();
  }, []);

  const getGraph = async () => {
    const res = await getPortfolioDashboardCostGraph(id, authToken);
    if (res?.data?.data?.values) {
      setOptions({
        ...options,
        series: res.data.data.values,
      });
    }
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CostGraph;
